import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  withStyles,
} from 'material-ui';
import MealSubselectionSwitchStyles from './MealSubselectionSwitchStyles';

const MealSubselectionSwitch = ({
  meals,
  label,
  name,
  value,
  parentValue,
  onSubselection,
  classes,
}) => (
  <div className={classes.root}>
    <FormControl component='fieldset' className={classes.formControl}>
      <FormLabel classes={{ root: classes.label, focused: classes.checked }}>{label}</FormLabel>
      <RadioGroup
        aria-label={`${name}Subselection`}
        name={`${name}Subselection`}
        className={classes.group}
        value={value}
        onChange={e => onSubselection(e, parentValue)}
      >
        {meals.map((meal, index) => (
          <FormControlLabel
            key={`meal-sub-item-${meal.id}-${index}`}
            value={meal.id}
            control={<Radio classes={{ checked: classes.checked }} />}
            label={meal.description}
            className={classes.item}
          />
        ))}
      </RadioGroup>
    </FormControl>
  </div>
);

MealSubselectionSwitch.propTypes = {
  classes: PropTypes.object,
  meals: PropTypes.arrayOf(PropTypes.object),
  parentValue: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  onSubselection: PropTypes.func,
};

export default withStyles(MealSubselectionSwitchStyles)(MealSubselectionSwitch);



// WEBPACK FOOTER //
// ./src/components/meals/mealSwitch/MealSubselectionSwitch.js